<template>
    <div v-if="mostrarPainel"  class="mt-2">
        <h4 class="heading-1">
            <span>Avaliações</span>
        </h4>
        <b-list-group>
            <AvaliacoesDespesasGeraisMenu></AvaliacoesDespesasGeraisMenu>
        </b-list-group>
    </div>
</template>

<script>
import AvaliacoesDespesasGeraisMenu from './avaliacoesDespesasGerais/AvaliacoesDespesasGeraisMenu.vue'

export default {
    components: {
        AvaliacoesDespesasGeraisMenu
    },
    computed: {
        mostrarPainel() {
            return this.$temAcessoView('DESP-GERAIS-REL-00')
        }
    }
}
</script>
